import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const deleteLeadTaskAPI = createAsyncThunk(
  "lead/deleteLeadTaskAPI",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}api/leads/tasks/${data.id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if(data.handleSuccessDelete){
        data.handleSuccessDelete()
      }
      return {...resp.data,id:data.id};
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
